import { mdiFormatText } from '@lumapps/lumx/icons';
import {
    STRUCTURED_CONTENT_SERIALIZATION_ELEMENTS,
    STRUCTURED_CONTENT_SERIALIZATION_MARKS,
} from '@lumapps/structured-content/constants';
import type { ConnectedWidgetProps } from '@lumapps/widget-base/components/Widget/ConnectedWidget';
import { getHtmlSerializationOptions } from '@lumapps/wrex/serialization/html/getHtmlConversionOptions';

import type { LegacyWidgetContributionProps } from './type';

export const WIDGET_CONTRIBUTION_TYPE = 'contribution';

export const BLOCK_STRUCTURED_CONTENT_CLASSNAME = 'block-structured-content';

export const WIDGET_CONTRIBUTION_ICON = mdiFormatText;

/**
 * Excluding `richText` from the queryKey because we don't want to re-fetch the widget in designer each time we update
 */
export const EXCLUDED_QUERY_KEY_WIDGET_PROPERTIES: ConnectedWidgetProps<LegacyWidgetContributionProps>['excludedQueryKeyWidgetProperties'] =
    ['richText'];

/** Rich text to html options to used with a toHTML() */
export const WIDGET_CONTRIBUTION_HTML_SERIALIZATION_OPTIONS = getHtmlSerializationOptions({
    elements: STRUCTURED_CONTENT_SERIALIZATION_ELEMENTS,
    marks: STRUCTURED_CONTENT_SERIALIZATION_MARKS,
});
